import ConfirmComponent from './confirm.vue'
const Confirm = {}

Confirm.install = function(Vue) {
  const ConfirmConstructor = Vue.extend(ConfirmComponent)
  const instance = new ConfirmConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$confirm = (message, title, params) => {
    instance.show = true
    if (params.message || typeof (message) === 'string') {
      instance.message = message || params.message
    }
    if (params.title || typeof (title) === 'string') {
      instance.title = title || params.title
    }
    Object.keys(params).forEach(key => {
      const obj = instance[key]
      if (Object.prototype.toString.call(obj) === '[object Object]') {
        instance[key] = Object.assign({}, obj, params[key])
      } else {
        instance[key] = params[key]
      }
    })
    return new Promise((resolve, reject) => {
      instance.submitAction = resolve
      instance.cancleAction = reject
    })
  }
}

export default Confirm
